import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'

export function* addStore(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.STORE.ADD_STORE, data);
        // console.log(resp);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}


export function* getStore(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STORE.GET_STORE, {}, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* updateStoreInfo(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.PUT, APIS.STORE.UPDATE_STORE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* addStoreBranch(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.STORE.ADD_BRANCH, data);
        // console.log(resp);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* updateStoreBranchInfo(action: any): any {
    try {
        const data = action.payload;
        const params = {
            branch_name: data.branch_name,
            address: data.address,
            contact_info: data.contact_info,
        }

        const resp = yield call(CallApi.PUT, APIS.STORE.UPDATE_BRANCH + data.branch_id, params);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getStoreBranches(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STORE.BRANCH_LIST + data.store_id + '/branches', {}, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}


export function* getStoreTypes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STORE.GET_STORE_TYPE, {}, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}